import React from 'react';

// Placeholders until the data lands, with the shapes the case list uses.
export const TableSkeleton: React.FC<{ columns: number; rows?: number }> = ({ columns, rows = 5 }) => (
  <div role="status" aria-label="Loading">
    <table className="certification-table" style={{ tableLayout: 'fixed' }} aria-hidden="true">
      <tbody>
        {Array.from({ length: rows }, (_, row) => (
          <tr key={row}>
            {Array.from({ length: columns }, (_, column) => (
              <td key={column}>
                <span className="skeleton-bar skeleton-shimmer" style={{ width: `${55 + ((row * 17 + column * 11) % 35)}%` }} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const BlockSkeleton: React.FC<{ lines?: number }> = ({ lines = 6 }) => (
  <div role="status" aria-label="Loading">
    {Array.from({ length: lines }, (_, line) => (
      <p key={line} aria-hidden="true">
        <span className="skeleton-bar skeleton-shimmer" style={{ width: `${50 + ((line * 17) % 40)}%` }} />
      </p>
    ))}
  </div>
);
